module.exports = __webpack_public_path__ + "static/media/email_icon.ca7c7df1.svg";